import { taskAxiosInstance } from "../axiosInstance";

export interface TaskImage {
    id: number;
    taskId: number;
    s3Key: string;
    fileName: string;
    createdAt: string;
    updatedAt: string;
    deletedAt: string | null;
    createdById: number;
    updatedById: number;
}

export interface TaskImageListResponse {
    data: TaskImage[];
    total: number;
}

export interface TaskImageUrl {
    id: number;
    url: string;
    expiresAt: number;
}

export const getTaskImages = async (taskId: number): Promise<TaskImageListResponse> => {
    const response = await taskAxiosInstance.get<TaskImageListResponse>(
        `/task-images?taskId=${taskId}`,
    );
    return response.data;
};

export const uploadTaskImage = async (taskId: number, file: File): Promise<TaskImage> => {
    const formData = new FormData();
    formData.append("file", file);
    const response = await taskAxiosInstance.post<TaskImage>(
        `/task-images?taskId=${taskId}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
    );
    return response.data;
};

export const getTaskImageUrl = async (id: number): Promise<{ url: string; expiresAt: number }> => {
    const response = await taskAxiosInstance.get<{ url: string; expiresAt: number }>(
        `/task-images/${id}/url`,
    );
    return response.data;
};

export const getBatchTaskImageUrls = async (ids: number[]): Promise<TaskImageUrl[]> => {
    if (ids.length === 0) return [];

    const response = await taskAxiosInstance.post<TaskImageUrl[]>(`/task-images/batch-urls`, {
        ids,
    });
    return response.data;
};

export const deleteTaskImage = async (id: number): Promise<TaskImage> => {
    const response = await taskAxiosInstance.post<TaskImage>(`/task-images/${id}/delete`);
    return response.data;
};

export const restoreTaskImage = async (id: number): Promise<TaskImage> => {
    const response = await taskAxiosInstance.post<TaskImage>(`/task-images/${id}/restore`);
    return response.data;
};

export const hardDeleteTaskImage = async (id: number): Promise<TaskImage> => {
    const response = await taskAxiosInstance.post<TaskImage>(`/task-images/${id}/hard-delete`);
    return response.data;
};
